<template>
  <div class="animated fadeIn">
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <div slot="header">
              <strong>Pattern Detail</strong>
                <label class="switch switch-sm switch-text switch-info mb-0">
                  <input type="checkbox" class="switch-input" v-model="model.is_use" id="ph_use">
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
            </div>
            <b-form-group>
              <label for="ph_type">Category</label>
              <b-form-select v-model="model.category" :options="codes.code_category" :disabled="lock"></b-form-select>
            </b-form-group>
            <b-form-group>
              <label for="ph_ext">Ext</label>
            <b-form-select v-model="model.ext" :options="codes.code_ext" :disabled="lock"></b-form-select>
            </b-form-group>
            <b-form-group>
              <label for="ph_type">Type</label>
              <b-form-select v-model="model.type" :options="codes.code_type" :disabled="lock"></b-form-select>
            </b-form-group>
            <b-form-group>
              <label for="ph_code">Code</label>
              <b-form-input md=5 type="text" id="ph_code" v-model="model.code" :disabled="lock"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="ph_content">Description</label>
              <b-form-textarea :rows="3" v-model="model.description" id="ph_content" :disabled="lock"></b-form-textarea>
            </b-form-group>
            <b-form-group label="Active Use" label-for="ph_active" v-b-tooltip.hover>
              <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
            </b-form-group>
            <hr>
            <b-button size="sm" variant="warning" @click="edit"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </b-card>
        </b-col>
      </b-row>
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
     Would you Like to Remove?
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: {
    cSwitch,
  },
  data : () => { return { codes:codes, confirm: false, add: false, lock: true, model : {} } },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_upattern'}); },
    edit() { this.$router.replace({ name: 'wsfinder_upattern', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try{
        let rs = await Api.Manager_Call('wsfinder.user.pattern', 'delete', { id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('wsfinder.user.pattern', 'detail', { id : id})
        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('pattern.detail.vue', 'created'); },
  destroyed: function() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}
</script>
